(function () {
  'use strict';

  /*
   * Diwali delivery cut-off banner for the product-page pincode checker.
   * Cut-offs use the same max-days per zone as pincode-delivery-checker.js
   * (delhi 2, metro 4, rest 7, remote 10). Hides itself after Diwali.
   */
  var DIWALI = new Date('2026-11-08T23:59:59+05:30');
  var CUTOFFS = [
    { label: 'Rest of India', days: 7 },
    { label: 'Metro cities', days: 4 },
    { label: 'Delhi NCR', days: 2 }
  ];
  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

  function cutoffDate(days) {
    var d = new Date(DIWALI);
    d.setDate(d.getDate() - days);
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function endOfDay(d) {
    var e = new Date(d);
    e.setHours(23, 59, 59, 999);
    return e;
  }

  function countdown(to) {
    var ms = endOfDay(to) - new Date();
    if (ms <= 0) return null;
    var d = Math.floor(ms / 864e5);
    var h = Math.floor(ms / 36e5) % 24;
    var m = Math.floor(ms / 6e4) % 60;
    var s = Math.floor(ms / 1e3) % 60;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    return (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  // Chip text: "6d left" while days remain, then "14h left" on the last day.
  function daysLeft(to) {
    var ms = endOfDay(to) - new Date();
    var d = Math.floor(ms / 864e5);
    if (d >= 1) return '<b>' + d + 'd</b><span>to order</span>';
    return '<b>' + Math.max(1, Math.ceil(ms / 36e5)) + 'h</b><span>to order</span>';
  }

  function renderBanner(el) {
    var title = el.querySelector('[data-dw-title]');
    var count = el.querySelector('[data-dw-count]');
    var zones = el.querySelector('[data-dw-zones]');

    function tick() {
      var now = new Date();
      if (now > DIWALI) { el.remove(); return false; }
      var open = CUTOFFS.filter(function (c) { return now <= endOfDay(cutoffDate(c.days)); });
      if (!open.length) {
        title.innerHTML = 'Happy Diwali from CaseCrush';
        if (count) count.hidden = true;
        zones.textContent = 'Check your pincode below for the latest delivery date.';
        return true;
      }
      var first = open[0];
      title.innerHTML = 'Get it before <strong>Diwali</strong>';
      if (count) count.innerHTML = daysLeft(cutoffDate(first.days));
      zones.innerHTML = '<span class="cc-dw__label">Last day to order:</span>' +
        '<span class="cc-dw__row2">' + open.map(function (c) {
          return '<span class="cc-dw__zone">' + c.label + '<b>' + fmt(cutoffDate(c.days)) + '</b></span>';
        }).join('') + '</span>';
      return true;
    }

    if (!tick()) return;
    el.hidden = false;
    var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 60000);
  }

  // Reads the "Arrives Sat, 1 Nov – Mon, 3 Nov" text from the checker result
  // and appends a before/after Diwali verdict.
  function latestArrival(text) {
    var m = text.match(/(\d{1,2})\s+([A-Za-z]{3})[^0-9]*$/);
    if (!m) return null;
    var mon = MONTHS[m[2].toLowerCase()];
    if (mon === undefined) return null;
    var now = new Date();
    var d = new Date(now.getFullYear(), mon, Number(m[1]), 12);
    if (d < now && now.getMonth() === 11 && mon === 0) d.setFullYear(d.getFullYear() + 1);
    return d;
  }

  function annotate(result) {
    if (new Date() > DIWALI) return;
    var dateEl = result.querySelector('.pincode-checker__result-date');
    if (!dateEl || result.querySelector('.cc-diwali-verdict')) return;
    var arrival = latestArrival(dateEl.textContent);
    if (!arrival) return;
    var ok = arrival <= DIWALI;
    var p = document.createElement('p');
    p.className = 'cc-diwali-verdict ' + (ok ? 'cc-diwali-verdict--ok' : 'cc-diwali-verdict--late');
    p.textContent = ok ? 'Arrives before Diwali' : 'May arrive after Diwali';
    dateEl.insertAdjacentElement('afterend', p);
  }

  function init(root) {
    var banner = root.querySelector('[data-diwali-cutoff]');
    if (banner) renderBanner(banner);
    var result = root.querySelector('[data-pincode-result]');
    if (!result) return;
    new MutationObserver(function () { annotate(result); }).observe(result, { childList: true });
  }

  document.querySelectorAll('[data-pincode-checker]').forEach(init);
})();
